import React from "react";
import { Pressable, Text, View } from "react-native";
import MaterialIcons from "react-native-vector-icons/MaterialIcons";
import styles from "../TicketDetailScreenStyles";
import { useTheme } from "../../../theme";

type Props = {
  /** The source screen label used to build the back-button text (e.g. "My Tickets"). */
  ticketDetailSource: string;
  onNavigateBack: () => void;
};

/**
 * Full-screen "Access Denied" card shown when the current user does not have
 * permission to view a ticket (i.e. they are not the submitter, a secondary
 * stakeholder, or a Sustain Team member).
 */
const TicketAccessDenied: React.FC<Props> = ({ ticketDetailSource, onNavigateBack }) => {
  const { colors, resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";
  const backLabel =
    ticketDetailSource === "Homepage Banner"
      ? "Ticketing Portal"
      : ticketDetailSource || "My Tickets";

  return (
    <View style={[styles.screenRoot, isDark && { backgroundColor: colors.background.page }]}>
      <View
        style={[
          styles.container,
          { justifyContent: "center", alignItems: "center", paddingHorizontal: 24 },
        ]}
      >
        <View
          style={{
            width: "100%",
            maxWidth: 640,
            backgroundColor: isDark ? colors.background.surface : "#ffffff",
            borderWidth: 1,
            borderColor: isDark ? colors.border.default : "#e5e7eb",
            borderRadius: 12,
            padding: 20,
          }}
        >
          {/* Header row */}
          <View style={{ flexDirection: "row", alignItems: "center", marginBottom: 10 }}>
            <MaterialIcons name="lock" size={20} color="#b91c1c" />
            <Text style={{ marginLeft: 8, fontSize: 18, fontWeight: "700", color: isDark ? colors.text.primary : "#111827" }}>
              Access Denied
            </Text>
          </View>

          {/* Message */}
          <Text style={{ fontSize: 14, lineHeight: 22, color: isDark ? colors.text.secondary : "#374151", marginBottom: 16 }}>
            Access denied. You do not have permission to view this ticket.
          </Text>

          {/* Back button */}
          <Pressable
            style={({ pressed }) => [
              {
                alignSelf: "flex-start",
                flexDirection: "row",
                alignItems: "center",
                backgroundColor: isDark ? colors.brand.primary : "#034895",
                borderRadius: 8,
                paddingHorizontal: 14,
                paddingVertical: 10,
              },
              pressed && { opacity: 0.85 },
            ]}
            onPress={onNavigateBack}
          >
            <MaterialIcons name="chevron-left" size={18} color="#ffffff" />
            <Text style={{ color: "#ffffff", fontSize: 14, fontWeight: "700" }}>
              Back to {backLabel}
            </Text>
          </Pressable>
        </View>
      </View>
    </View>
  );
};

export default TicketAccessDenied;
